/**
 * web/src/api/auth.ts
 * Login + logout glue. Login is a full-page redirect to /auth/login (Arctic
 * OAuth flow needs the browser to follow the 302 to Google — fetch can't
 * because the response sets cookies and Set-Cookie isn't observable from JS).
 * Logout is a real POST that clears the session row and cookie.
 *
 * Note: auth routes live under /auth/* (Phase 2 server.ts), NOT /api/auth/*.
 */
import { api } from '../lib/api';

/**
 * Build the login URL, optionally carrying a `next` redirect that the
 * server will validate against safeRedirect's allowlist (D-A01) before
 * sending the user back after OAuth completes.
 *
 * @param next optional path on the same origin; URL-encoded into the query
 * @returns absolute path string suitable for `window.location.assign(...)`
 * @sideEffects none (pure)
 * @idempotent yes
 */
export function loginUrl(next?: string): string {
  return next ? `/auth/login?next=${encodeURIComponent(next)}` : '/auth/login';
}

/**
 * POST /auth/logout — server destroys the session row and clears the cookie.
 *
 * @returns void
 * @throws ApiClientError on non-2xx (rare — logout is best-effort)
 * @sideEffects performs an HTTP POST with credentials: 'include'
 * @idempotent yes — repeated calls clear an already-empty session
 */
export async function logout(): Promise<void> {
  await api('/auth/logout', { method: 'POST' });
}
